import { render, staticRenderFns } from "./copyright.vue?vue&type=template&id=3e58a5b5&scoped=true&lang=pug"
import script from "./copyright.vue?vue&type=script&lang=coffee"
export * from "./copyright.vue?vue&type=script&lang=coffee"
import style0 from "./copyright.vue?vue&type=style&index=0&id=3e58a5b5&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e58a5b5",
  null
  
)

export default component.exports